import { useState, useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import Zoom from 'react-reveal/Zoom';
import videoBackground from '../../../assets/vid/video-background.mp4';
import './TitleSection.css';


function TitleSection() {
    const [offsetY, setOffsetY] = useState(0);

    const handleScroll = () => {
        setOffsetY(window.pageYOffset);
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    });

    return (
        <div id="title-section">
            <video id="video-background" autoPlay muted loop playsInline style={{ transform: `translateY(-${offsetY * 0.15}px)` }}>
                <source src={videoBackground} type="video/mp4" />
            </video>
            <div id="title-text-div">
                <h1 id="title-heading">Fuerza Coaching</h1>
                <Zoom>
                    <h2 className="title-subheading" id="title-subheading-name">DANIEL MORALES</h2>
                </Zoom>
                <div>
                    <Row>
                        <Col>
                            <Zoom delay={500}>
                                <h3 className="title-subheading title-subheading-roles">ONLINE COACH</h3>

                            </Zoom>
                        </Col>
                        <Col>
                            <Zoom delay={1000}>
                                <h3 className="title-subheading title-subheading-roles">PERSONAL TRAINER</h3>

                            </Zoom>
                        </Col>
                        <Col>
                            <Zoom delay={1500}>
                                <h3 className="title-subheading title-subheading-roles" id="title-subheading-bodybuilder">PRO BODYBUILDER</h3>
                            </Zoom>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default TitleSection;